import styled from "styled-components";

interface IWrapperProps {
  hasSectors?: boolean;
  top?: number;
}

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px;
`;
export const PSLPerformanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px;
  gap: 20px;
  background-color: #e4e5e7;
  overflow: auto;
`;

export const PerformanceCard = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-right: 20px;
  border-right: 1px solid #0000001a;
  :last-child {
    border: none;
    padding-right: 0px;
  }
  @media (max-width: 576px) {
    border-right: none;
    padding-right: 0px;
    padding-bottom: 20px;
    border-bottom: 1px solid #0000001a;
  }
  .tooltip-max-width {
    max-width: 20%;
  }

  @media (max-width: 768px) {
    .tooltip-max-width {
      max-width: 50%;
    }
  }
`;

export const AgencyRightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
`;
export const StarRatingSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
`;
export const StarRating = styled.img`
  width: 10px;
  height: 10px;
`;
export const AgencyImageSection = styled.div`
  position: relative;
`;
export const AgencyImage = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
`;

export const AgencyProfileLabel = styled.div`
  width: 50px;
  height: 10px;
  background-color: #ed428c;
  color: #ffffff;
  object-fit: cover;
  border-radius: 1px;
  display: flex;
  align-items: center;
  font-size: 7px;
  font-weight: 700;
  justify-content: center;
  position: relative;
  bottom: 10px;
`;

export const AgencyCard = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 2px;
  border: 0.5px solid #0000001a;
  padding: 6px;
  justify-content: space-between;
  align-items: center;
`;
export const AgencyDetails = styled.div`
  display: flex;
  flex-direction: column;
  color: #565656;

  h6 {
    font-size: 12px;
    margin-bottom: 5px;
  }
  h6:last-child {
    margin-bottom: 0px;
  }
  h5 {
    font-size: 12px;
    margin-bottom: 5px;
  }
  h4 {
    font-size: 12px;
    color: #402680;
    margin-bottom: 5px;
  }
  h3 {
    font-size: 14px;
    color: #402680;
    margin-bottom: 5px;
  }
`;
export const AgencyBottomSection = styled.div`
  margin-top: 10px;
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  font-weight: 500;
  justify-content: space-between;
  align-items: center;
  h4 {
    color: #ed428c;
    font-weight: 800;
    font-size: 12px;
  }
`;
export const AgencyBottomSectionTitle = styled.div`
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
`;
export const SectorSection = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  width: ${(props: IWrapperProps) => (props?.hasSectors ? "auto" : "100%")};
  height: ${(props: IWrapperProps) => (props?.hasSectors ? "auto" : "100%")};
  justify-content: ${(props: IWrapperProps) =>
    props?.hasSectors ? " flex-start" : "center"};
`;

export const Sector = styled.div`
  padding: 5px;
  background: ${(props) => props.color || "transparent"};
  border-radius: 3px;
  font-size: 12px;
  color: #000000;
  display: flex;
  gap: 10px;
  align-items: center;
  span {
    font-weight: bold;
    font-family: "Montserrat";
  }
`;

export const CandidateInfoSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;
export const CandidateInfo = styled.div`
  border: 0.5px solid #00000033;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 400;
  color: #000000;
  flex-direction: column-reverse;
  text-align: center;
  width: calc(50% - 5px);
  height: 60px;
  padding: 3px;
  span.value {
    font-family: "Montserrat";
    color: #000000;
    // #ed4292
    font-weight: bold;
    font-size: 12px;
  }
`;
export const JobInfoSection = styled(CandidateInfoSection)``;
export const JobsInfo = styled(CandidateInfo)``;
export const FeesInfoSection = styled(CandidateInfoSection)``;
export const FeesInfo = styled(CandidateInfo)``;

export const Title = styled.div`
  font-size: 16px;
  color: #343333;
  font-family: "Komet";
  font-weight: 700;
  text-align: center;
  margin-bottom: 15px;
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const LineBreak = styled.div`
  //   height: 100%;
  //   width: 1px;
  //   background: #0000001a;
  //   position: absolute;
  //   right: -20px;
  //   @media (max-width: 768px) {
  //     width: 100%;
  //     height: 1px;
  //     top: -10px;
  //     left: 0px;
  //   }
`;

export const PSLHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 0 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  transition: top 0.3s ease, background-color 0.3s ease;
  // z-index: 1000;

  &.sticky {
    position: fixed;
    top: ${(props: IWrapperProps) => props?.top}px;
    z-index: 1000;
    width: calc(100% - 100px);
  }
  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    display: none;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const PSLHeaderColumn = styled.div`
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  padding-right: 20px;
  border-right: 1px solid #0000001a;
  padding: 20px 0px;
  padding-right: 20px;
  text-align: center;
  font-size: 16px;
  color: #343333;
  font-family: "Komet";
  font-weight: 700;
  text-align: center;
  :last-child {
    padding-right: 0px;
    border: none;
  }
`;
export const AgencyNameLink = styled.a`
  transition: 0.1s ease-in-out;
  text-decoration: underline !important;

  &:hover {
    color: #402680 !important;
  }
`;
